import {
  PRODUCTOPTION_LOADING,
  GET_PRODUCTOPTION,
  GET_PRODUCTOPTION_SUCCESS,
  GET_PRODUCTOPTION_FAIL,
  ADD_PRODUCTOPTION_SUCCESS,
  ADD_PRODUCTOPTION_FAIL,
  DELETE_PRODUCTOPTION_SUCCESS,
  DELETE_PRODUCTOPTION_FAIL,
  UPDATE_PRODUCTOPTION_SUCCESS,
  UPDATE_PRODUCTOPTION_FAIL,
  PRODUCTOPTION_RESET
} from "./actionType";

const INIT_STATE = {
  productOptions: [],
  error: {},
};

const ProductOption = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTOPTION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTOPTION:
          return {
            ...state,
            productOptions: action.payload.data,
            isProductOptionCreated: false,
            isProductOptionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTOPTION_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTOPTION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductOptionCreated: false,
            isProductOptionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTOPTION: {
      return {
        ...state,
        isProductOptionCreated: false,
        loading: true,
      };
    }

    case PRODUCTOPTION_LOADING: {
      return {
        ...state,
        isProductOptionCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTOPTION_SUCCESS:
      return {
        ...state,
        isProductOptionCreated: true,
        loading: false,
        productOptions: [action.payload.data, ...state.productOptions],
      };

    case ADD_PRODUCTOPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTOPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductOptionCreated: true,
        productOptions: state.productOptions.filter(
          productOption => productOption.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTOPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTOPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductOptionCreated: true,
        productOptions: state.productOptions.map(productOption =>
          productOption.id.toString() === action.payload.data.id.toString() ? { ...productOption, ...action.payload.data } : productOption
        ),
      };

    case UPDATE_PRODUCTOPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTOPTION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductOption;